import { observer } from 'mobx-react-lite';

import { ModalsManager } from '@/components/modals/modalsManager';
import { ReferralModal } from '@/features/referral';
import { cn } from '@/lib/utils';
import { trackEvent } from '@/utils/analytics';

import { subscriptionStore } from './subscription.store';
import { SubscriptionPlan } from './subscription.types';

interface ReferralCtaProps {
  source: string;
  className?: string;
}

export const ReferralCta = observer(
  ({ source, className }: ReferralCtaProps) => {
    if (subscriptionStore.currentPlan !== SubscriptionPlan.BASIC) return null;

    const isActivity =
      subscriptionStore.state.userReferralRewardType === 'activity_based';

    const handleClick = () => {
      trackEvent('REFERRAL_CTA_CLICKED', {
        source,
        experiment_variant: isActivity ? 'activity_based' : 'payment_based',
      });
      ModalsManager.show(ReferralModal, {});
    };

    return (
      <button
        onClick={handleClick}
        className={cn(
          'text-xs text-foreground-muted hover:text-foreground-subtle underline underline-offset-2 transition-colors whitespace-nowrap',
          className
        )}
      >
        {isActivity ? 'or get 1 free month' : 'or get 2 free months'}
      </button>
    );
  }
);
